import { Stack } from '@mui/material';
import { Typography } from '@uy3/web-components';
import { SpanCustom } from 'components/HelpPermission/HelpPermission';
import { formatCpfOrCnpj, formatCurrencyInCents } from 'helpers';
import React, { ReactNode } from 'react';

type TooltipConsignmentProps = {
    values: {
        DescTipoVinc: string;
        CodOrgao: string;
        NmOrgao: string;
        CnpjOrgao: string;
        CodSituacaoFuncional: string;
        DescSituacaoFuncional: string;
        DatasValidade: string[];
        CdRubrica: string;
        DsRubrica: string;
        CdMatricula: string;
        totalMargem: number;
        Contratos: {
            contrato: string;
            nome: string;
            valor: number;
            validade: string;
        }[];
    };
    currentIndex: number;
};

export const TooltipConsignment: React.FC<TooltipConsignmentProps> = ({ values, currentIndex }) => {
    const {
        DescTipoVinc,
        CodOrgao,
        NmOrgao,
        CnpjOrgao,
        CodSituacaoFuncional,
        DescSituacaoFuncional,
        CdRubrica,
        DsRubrica,
        CdMatricula,
        Contratos,
    } = values;

    const ListItem: React.FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
        <Typography style={{ margin: '5px 0', fontSize: '14px' }}>
            <SpanCustom>{label}: </SpanCustom>
            {value}
        </Typography>
    );

    return (
        <Stack sx={{ margin: '5px 0' }} spacing={2}>
            <Typography variant="md" fontWeight="bold" textAlign="center">
                Informações / Detalhes
            </Typography>

            {Contratos.map((contrato, index) => (
                <Stack key={index} spacing={1}>
                    <ListItem label="Número do Contrato" value={contrato.contrato} />
                    <ListItem label="Matrícula" value={CdMatricula} />
                    <ListItem label="Tipo de Vínculo" value={DescTipoVinc} />
                    <ListItem label="Órgão" value={`${NmOrgao} (${CodOrgao})`} />
                    <ListItem label="CNPJ do Órgão" value={formatCpfOrCnpj(CnpjOrgao)} />
                    <ListItem
                        label="Situação Funcional"
                        value={`${DescSituacaoFuncional} (${CodSituacaoFuncional})`}
                    />
                    <ListItem label="Rubrica" value={`${CdRubrica} - ${DsRubrica}`} />
                    <ListItem label="Valor Parcela" value={formatCurrencyInCents(contrato.valor)} />
                    <ListItem label="Data de Validade" value={contrato.validade} />
                </Stack>
            ))}
        </Stack>
    );
};
